import { useNavigate } from 'react-router-dom';
import { applicationRoles } from 'config/authConfigB2C';
import { useMsal } from "@azure/msal-react";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import FlagIcon from '@mui/icons-material/Flag';
import ConstructionIcon from '@mui/icons-material/Construction';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import PeopleIcon from '@mui/icons-material/People';
import AssessmentIcon from '@mui/icons-material/Assessment'

import HeaderBar from 'components/library/pages/HeaderBar';

export default function ApplicationHeader({
    logo,
    title
}) {
    const navigate = useNavigate();
    const { accounts, instance } = useMsal();
    const userName = accounts[0] && accounts[0].name;

    const logoutHandler = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
            mainWindowRedirectUri: "/"
        });
    }

    const createHeaderItems = () => (
        [{
            label: 'Reports', type: 'menu', items: [
                { label: "Dashboard", startIcon: <AssessmentIcon />, action: () => navigate('/') }
            ]
        },
        {
            label: 'List All', type: 'menu', items: [
                { label: "Shipment Notifications", startIcon: <NotificationsActiveIcon />, action: () => navigate('/notifications') },
                { label: "Escalations", startIcon: <FlagIcon />, action: () => navigate('/escalations') },
                { label: "Work in Progress records", startIcon: <ConstructionIcon />, action: () => navigate('/wips') },
                { label: "Users", startIcon: <PeopleIcon />, allowFor: [applicationRoles.INTERNAL_CUSTOMER_CS3], action: () => navigate('/users') },
                { label: "Load Status", startIcon: <PublishedWithChangesIcon />, action: () => navigate('/loadstatus') },
            ]
        },
        {
            label: 'Create', type: 'menu', allowFor: [applicationRoles.EXTERNAL_CUSTOMER], items: [
                {
                    label: "Shipment Notification", startIcon: <NotificationsActiveIcon />, action: () => navigate('/notifications/new')
                }
            ]
        }
        ]
    )

    return <HeaderBar logo={logo} title={title} renderMenus={createHeaderItems} userName={userName} logoutHandler={logoutHandler} />
}